<!-- =========================================================================================
  File Name: DashboardAnalytics.vue
  Description: Dashboard Analytics
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div class="relative mb-20 md:mb-0 ">
    <Pagesubtitle subTitle="Manage your login information."/>
    <savebutton submitText="Save" :accept="updateName" :goodToGo="formReady" />
    <vx-card>
    <div class="vx-row">
      <div class="vx-col md:w-1/2 w-full my-2">
        <vs-input
            v-model="name"
            label="First name"
            v-validate="'required|max:20'"
            name="first name"
            placeholder="e.g. Jane"
            class="w-full"
            />
        <span class="text-danger block mt-2">{{ errors.first('first name') }}</span>
      </div>
      <div class="vx-col md:w-1/2 w-full my-2">
        <vs-input
            :value="$store.state.auth.firebaseUser.email"
            label="Email address"
            readonly="true"
            class="w-full"
            />
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col md:w-1/2 w-full my-2">
        <a class="block" @click.prevent="showResetPassword = true" href="">Change Password ></a>
        <vs-prompt
          title="Change password"
          :active.sync="showResetPassword"
          accept-text="Change password"
          :is-valid="currentPassword !== '' && newPassword !== '' && !errors.first('password') && !(errors.first('new password') || passwordMsg)"
          @accept="resetPassword"
          @cancel="clearData"
          @close="clearData"
          >
          <vs-input
            v-model="currentPassword"
            v-validate="'required|min:6|max:15'"
            name="password"
            label="Current password"
            data-vv-validate-on="blur"
            type="password"
            placeholder="Current password"
            class="w-full my-6" />
          <span class="text-danger block my-2 text-sm">{{ errors.first('password') }}</span>
          <vs-input
            v-model="newPassword"
            v-validate="'required|min:6|max:15'"
            type="password"
            name="new password"
            label="New password"
            placeholder="New password"
            @blur="checkPWAlpha"
            class="w-full my-6" />
          <span class="text-danger block my-2 text-sm" v-if="errors.first('new password') || passwordMsg">{{ errors.first('new password') ? errors.first('password') : passwordMsg }}</span>
        </vs-prompt>
      </div>
      <div class="vx-col md:w-1/2 w-full my-2">
        <a class="block" @click.prevent="showResetEmail = true" href="">Change Email Address ></a>
        <vs-prompt

          :is-valid="currentPassword !== '' && newEmail !== '' && !errors.first('current password') && !errors.first('new email')"
          title="Change email address"
          :active.sync="showResetEmail"
          accept-text="Change email"
          @accept="resetEmail"
          @close="clearData"
          @cancel="clearData"
          >
          <vs-input
            v-model="currentPassword"
            v-validate="'required|min:6|max:15'"
            data-vv-validate-on="blur"
            name="current password"
            label="Current password"
            type="password"
            placeholder="Current password"
            class="w-full my-6" />
          <span class="text-danger block my-2 text-sm" v-if="errors.first('current password')">{{ errors.first('pass word') }}</span>
          <vs-input
            v-model="newEmail"
            v-validate="'required|email|max:60'"
            data-vv-validate-on="blur"
            name="new email"
            label="New email address"
            placeholder="New email address"
            class="w-full my-6" />
          <span class="text-danger block my-2 text-sm" v-if="errors.first('new email')">{{ errors.first('new email') }}</span>
        </vs-prompt>
      </div>
    </div>
    </vx-card> 
  </div>
</template>


<script>


/*


FLB ADMIN FEATURES


   <vx-card class="mt-base" v-if="showAdvanced">
      <div class="vx-row">
        <div class="vx-col w-full md:w-1/2 my-2 pb-10">
          <h2 class="mb-4">Advanced options</h2>
          <h4>Subscribe for free</h4>
          <vs-input
            v-model="freeBID"
            v-validate="'required|min:6'"
            data-vv-validate-on="blur"
            name="Free BID"
            placeholder="Business ID"
            label="Busines ID"
            class="w-full my-6" />
          <span class="text-danger block my-2 text-sm" v-if="errors.first('Free BID')">{{ errors.first('Free BID') }}</span>
          <vs-input
            v-model="freeUID"
            v-validate="'required|min:6'"
            data-vv-validate-on="blur"
            name="Free UID"
            placeholder="UID"
            label="UID of customer"
            class="w-full my-6" />
          <span class="text-danger block my-2 text-sm" v-if="errors.first('Free UID')">{{ errors.first('Free UID') }}</span>
          <vs-input
            v-model="freePlanID"
            v-validate="'required|min:2'"
            data-vv-validate-on="blur"
            name="Free PlanID"
            placeholder="Plan ID"
            label="Plan ID"
            class="w-full my-6" />
          <span class="text-danger block my-2 text-sm" v-if="errors.first('Free PlanID')">{{ errors.first('Free PlanID') }}</span>
          <vs-input
            v-model="freeAppSumoCode"
            v-validate="'min:6'"
            data-vv-validate-on="blur"
            name="Free ASC"
            placeholder="AppSumo Code if Required"
            label="AppSumo Code"
            class="w-full my-6" />
          <span class="text-danger block my-2 text-sm" v-if="errors.first('Free ASC')">{{ errors.first('Free ASC') }}</span>
          <vs-button @click="customSubscribe">Submit</vs-button>
          <span class="text-danger block my-2 text-sm">{{ customMSG }}</span>
        </div>
        <div class="vx-col w-full md:w-1/2 my-2">
        </div>
      </div>
    </vx-card>


*/


import Savebutton from './components/ptcomponents/Savebutton.vue'
import Pagesubtitle from './components/ptcomponents/Pagesubtitle.vue'

function isAlphaNumeric(myString) {
  return (/\d/.test(myString) && (myString.match(/[a-z]/i)))
}

export default {
  data () {
    return {
      showResetPassword: false,
      showResetEmail: false,
      setupData: false,
      currentPassword: '',
      freeAppSumoCode: '',
      //FOR THIS FEATURE I DONT WANT TO MUTATE STORE AUTH VIEWDATA DIRECTLY, SO RATHER SETTING UP LOCAL STATE:
      newEmail: '',
      newPassword: '',
      passwordMsg: false,
      name: '',
      freeBID: '',
      freeUID: '',
      freePlanID: '',
      customMSG: ''
    }
  },
  watch: {
    password() {
      this.passwordMsg = ''
    }
  },
  components: {
    Savebutton,
    Pagesubtitle
  },
  computed: {
    formReady () {
      if (this.errors.first('first name')) return false
      if (this.setupData === this.name) return false
      return true
    }
  },
  methods: {
    clearData () {
      this.currentPassword = ''
      this.newPassword = ''
      this.newEmail = ''
    },
    checkPWAlpha () {
      if (this.newPassword !== '') {
        if (!isAlphaNumeric(this.newPassword)){
          this.passwordMsg = 'Password must contain at least one number and one letter.'
        }
      }
    },
    updateName () {
      this.$store.dispatch('auth/changeDisplayName', this.name).then(() => {
        this.$vs.notify({
          title: 'Change first name',
          text: 'First name updated successfully',
          color: 'success',
          time: 6500,
          iconPack: 'feather',
          icon:'icon-check'})
          this.initSetupState()
      }).catch(() => {
        this.$vs.notify({
          title: 'Change first name',
          text: 'Oops! Something went wrong, and we couldn\'t update your first name. Please try again, and reach out for support if it happens again.',
          color: 'warning',
          time: 10000,
          iconPack: 'feather',
          icon:'icon-alert-circle' })
      })
    },
    resetEmail () {
      this.$store.dispatch('auth/changeEmail', {
        password: this.currentPassword,
        newEmail: this.newEmail
      }).then(() => {
        this.$vs.notify({
          title: 'Changed email address',
          text: 'Email address updated successfully',
          color: 'success',
          time: 6500,
          iconPack: 'feather',
          icon:'icon-check'})
          this.initSetupState()
          this.clearData()
      }).catch(() => {
        this.$vs.notify({
          title: 'Change email address',
          text: 'We couldn\'t update your email address. Please make sure you enter your current password correctly. Try again, and tell us if this issue persists: support@feedback.link',
          color: 'warning',
          time: 10000,
          iconPack: 'feather',
          icon:'icon-alert-circle' })
          this.clearData()
      })
    },
    resetPassword () {
      this.$store.dispatch('auth/changePassword', {
        password: this.currentPassword,
        newPassword: this.newPassword
      }).then(() => {
        this.$vs.notify({
          title: 'Changed password',
          text: 'Password updated successfully',
          color: 'success',
          time: 6500,
          iconPack: 'feather',
          icon:'icon-check'})
          this.initSetupState()
          this.clearData()
      }).catch(() => {
        this.$vs.notify({
          title: 'Change password',
          text: 'We couldn\'t update your password. Please make sure you enter your current password correctly. Try again, and tell us if this issue persists: support@feedback.link',
          color: 'warning',
          time: 10000,
          iconPack: 'feather',
          icon:'icon-alert-circle' })
          this.clearData()
      })
    },
    initSetupState () {

      let dbName = this.$store.state.auth.firebaseUser.displayName === null ? '' : this.$store.state.auth.firebaseUser.displayName

      if (dbName.indexOf('|pt_aSCI') !== -1) {
        this.name = dbName.substr(0,dbName.indexOf('|pt_aSCI'))
      } else {
        this.name = dbName
      }

      this.setupData = this.name

    }
  },
  created () {
      this.initSetupState()
  }
}
</script>

<style lang="scss">
/*! rtl:begin:ignore */
#dashboard-analytics {
  .greet-user{
    position: relative;

    .decore-left{
      position: absolute;
      left:0;
      top: 0;
    }
    .decore-right{
      position: absolute;
      right:0;
      top: 0;
    }
  }

  @media(max-width: 576px) {
    .decore-left, .decore-right{
      width: 140px;
    }
  }
}
/*! rtl:end:ignore */
</style>
